import { Users, User } from '@/models/User';

const state = {
	users: new Users(),

};

const getters = {



};

const mutations = {};

const actions = {

	/**
	 * Loads all users, who have access to same projects as this user
	 *
	 * @returns {Promise}
	 */
	loadAll({ state }) {
		return new Promise((resolve, reject) => {
			state.users.fetch().then((resp) => {
				resolve(state.users);
			})
			.catch((e) => {
				dump('Error fetching users', e);
				reject(e);
			});
		});
	},

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
